import store from "../store";
import { resolveInternalRedirect } from "../helpers";

export default async (to, from, next) => {
  document.title =
    (to.meta.title || to.name) + " | " + process.env.VUE_APP_PROJECT_NAME;

  if (to.name != from.name) window.scrollTo(0, 0);

  const requiresAuth = to.meta.requiresAuth || false;
  const preventAuth = to.meta.preventAuth || false;
  const authenticated = store.getters.authenticated;
  const redirect = resolveInternalRedirect(to.query.redirect);

  if (requiresAuth && !authenticated) {
    return next({
      name: "SignIn",
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (preventAuth && authenticated) {
    return next(redirect || "/");
  }

  next();
};
